import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";

export default function ClosingCTA() {
  return (
    <section
      id="contact-cta"
      className="relative overflow-hidden bg-navy text-white"
      data-testid="closing-cta"
    >
      <div className="absolute inset-0 grid-texture opacity-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>Start a Conversation</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl">
              Let&rsquo;s build a fundraising campaign that earns trust.
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80">
              Tell us about your charity, your objectives and the supporters you want to reach.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/book-a-consultation"
              className="inline-flex items-center justify-center gap-2 bg-brand-green px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-brand-greenDeep"
              data-testid="cta-book-consultation"
            >
              Book a Consultation
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/join-our-team"
              className="inline-flex items-center justify-center gap-2 border border-white/40 px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-white hover:text-navy"
              data-testid="cta-join-team"
            >
              Join Our Fundraising Team
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
